/* 🤖 this file was generated by svg-to-ts */
export const IconBigBrandGoogle: {
    name: 'big-brand-google';
    data: string;
} = {
    name: 'big-brand-google',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path fill-rule="evenodd" d="M110.28 7.72H17.72a10 10 0 0 0-10 10v92.56a10 10 0 0 0 10 10h92.56a10 10 0 0 0 10-10V17.72a10 10 0 0 0-10-10m-26 43.5-9.42 9.4L40.26 26zM27.83 98.48v-69a6.07 6.07 0 0 1 3.4-5.48l40.23 40-40.23 40a6.07 6.07 0 0 1-3.4-5.52M40.26 102l34.6-34.6 9.42 9.39zm57.82-33.24-9.42 5.33L78.36 64l10.3-10.08 9.23 5.33a6.26 6.26 0 0 1 .19 9.51"/></svg>`,
};
